module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/materialdesignicons-webfont.svg?v=1.9.32
// module id = 15
// module chunks = 0